import { useEffect, useState, useCallback } from "react";
import { createBrowserHistory } from "history";
import { BrowserRouter as Router } from "react-router-dom";
import theme from "./theme/muiTheme";
import { ThemeProvider } from "@mui/material";
import { routes, nonAuthenticatedRoutes } from "./options/routes";
import Content from "./parts/Content";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { verify } from "./api";
import setLocalStorage from "./utils/helpers/setLocalStorage";

// Instantiate createBrowserHistory to enable redirecting if #! is in URL
const history = createBrowserHistory();

const App = () =>
{
  const [userAuthenticated, setUserAuthenticated] = useState();

  // Remove #! in URL and redirect user to relevant path
  const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
  if (path)
  {

    history.replace(path);
  }
  const searchUrlForToken = () =>
  {
    let hash = window.location.hash.replace(/#token:/, '');
    if (hash)
    {
      console.log(window.location)
    }

    return hash;
  }
  const getUserProfile = useCallback(async () =>
  {
    // Check if profile exists in local storage - redirect to home if trying to access unauthenticated route
    const activeRoute = window.location.pathname;
    var token = localStorage.getItem("token");
    if (!token &&
      searchUrlForToken())
    {
      token = searchUrlForToken();
      const data = await verify({ accessToken: token });
      data.data.noredir = true;
      setLocalStorage(data.data);
      //window.location.href = activeRoute;
    }
    const userProfile = localStorage.getItem("userProfile");
    const clubProfile = localStorage.getItem("clubProfile");



    if (!token)
    {
      setUserAuthenticated(false);
      if (
        !nonAuthenticatedRoutes.includes(activeRoute) &&
        !activeRoute.includes("/verify/") &&
        !activeRoute.includes("/accept-invitation/") &&
        !activeRoute.includes("/reset-password/") &&
        !activeRoute.includes("/share")
      )
      {
        var redirect = activeRoute;
        if (redirect === routes.login || redirect === routes.logout)
        {
          redirect = "";
        }
        var newUrl = routes.login;
        if (redirect && redirect.length > 0)
        {
          newUrl += "?redirect=" + redirect
        }

        window.location.href = newUrl;
      }
      return;
    }
    if (
      (token ||
        (userProfile && Object.keys(userProfile).length) ||
        (clubProfile && Object.keys(clubProfile).length)) &&
      nonAuthenticatedRoutes.some((v) => activeRoute.includes(v))
    )
    {
      if (!activeRoute.includes("share") && !activeRoute.includes("stats/print"))
      {
        // Redirect unless the route is a share route.
        window.location.href = routes.home;
        return;
      }
    }

    setUserAuthenticated(true);
  }, []);

  useEffect(() =>
  {
    getUserProfile();
  }, [getUserProfile]);

  if (userAuthenticated === "undefined")
  {
    return <div></div>;
  }
  return (
    <>
      <Router>
        <ThemeProvider theme={theme}>
          <div>
            <Content userAuthenticated={userAuthenticated} />
          </div>
        </ThemeProvider>
      </Router>
    </>
  );
};

export default App;
